export interface ICustomer {
  salesForceId: string;
  name: string;
}

export class Customer implements ICustomer {
  salesForceId: string;
  name: string;
  constructor(clone: Customer = null) {
    if (clone) {
      this.salesForceId = clone.salesForceId;
      this.name = clone.name;
    }
  }
}
